var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Panel from './panel';
import CatalogList from '../catalog-view/catalog-list';

import { MODE_IDLE, MODE_2D_ZOOM_IN, MODE_2D_ZOOM_OUT, MODE_2D_PAN, MODE_3D_VIEW, MODE_3D_FIRST_PERSON, MODE_WAITING_DRAWING_LINE, MODE_DRAWING_LINE, MODE_DRAWING_HOLE, MODE_DRAWING_ITEM, MODE_DRAGGING_LINE, MODE_DRAGGING_VERTEX, MODE_DRAGGING_ITEM, MODE_DRAGGING_HOLE, MODE_FITTING_IMAGE, MODE_UPLOADING_IMAGE, MODE_ROTATING_ITEM, MODE_WAITING_DRAWING_PIPE, MODE_DRAWING_PIPE, MODE_DRAGGING_PIPE } from '../../constants';

var VISIBILITY_MODE = {
    MODE_IDLE: MODE_IDLE
};

var CATALOG_STYLES = {
    containerStyles: {
        width: '100%',
        position: 'unset',
        backgroundColor: 'unset'
    },

    searchContainer: false,

    itemsStyle: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center'
    }

};

var PanelCatalog = function (_Component) {
    _inherits(PanelCatalog, _Component);

    function PanelCatalog(props, context) {
        _classCallCheck(this, PanelCatalog);

        var _this = _possibleConstructorReturn(this, (PanelCatalog.__proto__ || Object.getPrototypeOf(PanelCatalog)).call(this, props, context));

        _this.panelRef = React.createRef();
        _this.state = {
            newEmptyHover: false,
            newSelectedHover: false
        };
        return _this;
    }

    _createClass(PanelCatalog, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                Panel,
                { name: this.context.translator.t('Catalog'), isDesktop: this.props.isDesktop, opened: true },
                React.createElement(CatalogList, { state: this.props.state, width: 100, height: 60, style: CATALOG_STYLES })
            );
        }
    }]);

    return PanelCatalog;
}(Component);

export default PanelCatalog;


PanelCatalog.propTypes = {
    state: PropTypes.object.isRequired,
    isDesktop: PropTypes.bool.isRequired
};

PanelCatalog.contextTypes = {
    catalog: PropTypes.object.isRequired,
    translator: PropTypes.object.isRequired,
    projectActions: PropTypes.object.isRequired
};